module.exports = __webpack_public_path__ + "static/media/wiifit.11cacb64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/nintendo/wiifit.jpg
// module id = 760
// module chunks = 0